<template>
    <div>
        <div class="bg-gray-100 rounded p-4">
            <h2 class="h5 fw-semibold mb-3 d-flex align-items-center">
                <i class="fas fa-id-card mr-1" style="font-size: 20px"></i>
                Thông tin căn cước
            </h2>

            <div class="mb-4">
                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                    <form class="form" @submit.prevent="handleSubmit(submit)" autocomplete="off">
                        <!-- Thông tin từ mặt trước -->
                        <div class="border-left-primary ps-3 mb-4">
                            <h2 class="h6 fw-medium text-dark mb-1 ml-3">Thông tin mặt trước</h2>
                            <div class="row g-3 ml-1 mt-2">
                                <div class="col-12">
                                    <label class="form-label fw-medium text-dark">
                                        <i class="el-icon-user"></i>
                                        Họ và tên <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="full_name" name="Họ và tên"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <input
                                            ref="full_name" name="full_name"
                                            type="text"
                                            v-model="dataInfo.full_name"
                                            class="form-control mb-3"
                                            placeholder="Nhập họ và tên"
                                        />
                                        <div class="text-danger text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-medium text-dark">
                                        Số CCCD <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="id_number" name="Số căn cước"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <input
                                            type="text"
                                            v-model="dataInfo.id_number"
                                            class="form-control"
                                            placeholder="Số căn cước"
                                        />
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label fw-medium text-dark">
                                        <i data-lucide="calendar" class="me-1 icon-sm"></i>
                                        Ngày sinh <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="birthday" name="Ngày sinh"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <el-date-picker id="birthDay"
                                                        format="dd-MM-yyyy"
                                                        ref="birthday"
                                                        name="birthday"
                                                        value-format="dd-MM-yyyy"
                                                        type="date"
                                                        placeholder="Ngày sinh"
                                                        v-model="dataInfo.date_of_birth"
                                                        style="width: 100%;"
                                        ></el-date-picker>
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-medium text-dark">
                                        Giới tính <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="gender" name="Giới tính"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <el-select
                                            v-model="dataInfo.gender"
                                            class="w-100 form-select"
                                        >
                                            <el-option value="">Chọn giới tính</el-option>
                                            <el-option value="Nam">Nam</el-option>
                                            <el-option value="Nữ">Nữ</el-option>
                                        </el-select>
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label fw-medium text-dark">
                                        Quốc tịch <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="nationality" name="Quốc tịch"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <input
                                            type="text"
                                            v-model="dataInfo.nationality"
                                            class="form-control"
                                            placeholder="Quốc tịch"
                                        />
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 mb-3">
                                    <label class="form-label fw-medium text-dark">
                                        Quê quán <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="place_of_residence" name="Quê quán"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <textarea
                                            v-model="dataInfo.place_of_residence"
                                            class="form-control"
                                            rows="2"
                                            placeholder="Địa chỉ thường trú"
                                        ></textarea>
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 mb-3">
                                    <label class="form-label fw-medium text-dark">
                                        Nơi thường trú <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="place_of_origin" name="Nơi thường trú"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <textarea
                                            v-model="dataInfo.place_of_origin"
                                            class="form-control"
                                            rows="2"
                                            placeholder="Địa chỉ thường trú"
                                        ></textarea>
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>

                            </div>
                        </div>

                        <!-- Thông tin từ mặt sau -->
                        <div class="border-left-success ps-3">
                            <h3 class="h6 fw-medium text-dark mb-1 ml-3">Thông tin mặt sau</h3>

                            <div class="row g-3 ml-2">
                                <div class="col-12 mb-3 row">
                                    <div class="col-md-6">
                                        <label class="form-label fw-medium text-dark">
                                            Ngày cấp <span class="text-danger">*</span>
                                        </label>
                                        <ValidationProvider vid="issued_date" name="Ngày cấp"
                                                            rules="required"
                                                            v-slot="{ errors, classes }">
                                            <el-date-picker id="issued_date"
                                                            format="dd-MM-yyyy"
                                                            ref="issued_date"
                                                            name="issued_date"
                                                            value-format="dd-MM-yyyy"
                                                            type="date"
                                                            placeholder="Ngày sinh"
                                                            v-model="dataInfo.issued_date"
                                                            style="width: 100%;"
                                            ></el-date-picker>
                                            <div class="text-danger" data-field="name" data-validator="notEmpty">
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label fw-medium text-dark">
                                            Có giá trị đến <span class="text-danger">*</span>
                                        </label>
                                        <ValidationProvider vid="expiry_date" name="Giá trị"
                                                            rules="required"
                                                            v-slot="{ errors, classes }">
                                            <el-date-picker id="expiry_date"
                                                            format="dd-MM-yyyy"
                                                            ref="expiry_date"
                                                            name="expiry_date"
                                                            value-format="dd-MM-yyyy"
                                                            type="date"
                                                            placeholder="Có giá trị đến"
                                                            v-model="dataInfo.expiry_date"
                                                            style="width: 100%;"
                                            ></el-date-picker>
                                            <div class="text-danger" data-field="name" data-validator="notEmpty">
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label class="form-label fw-medium text-dark">
                                        Cơ quan cấp <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider vid="issued_place" name="Cơ quan cấp"
                                                        rules="required"
                                                        v-slot="{ errors, classes }">
                                        <input
                                            type="text"
                                            v-model="dataInfo.issued_place"
                                            class="form-control"
                                            placeholder="Cơ quan cấp căn cước"
                                        />
                                        <div class="text-danger" data-field="name" data-validator="notEmpty">
                                            {{ errors[0] }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>

                        <!-- Cập nhật nút Save -->
                        <div class="d-flex gap-2">
                            <button
                                type="submit"
                                class="btn flex-fill mt-4 fw-medium bg-violet text-white"
                            >
                                Lưu
                            </button>

                            <button
                                v-if="rawOcrText && !showRawText"
                                @click="showRawText = true"
                                class="btn btn-outline-info mt-4"
                                title="Xem văn bản OCR gốc"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </div>

                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import {SAVE_IDENTITY_CARD_INFO} from "../../../../core/services/store/profile.module";

export default {
    name: "IdentificationInformation",
    data()
    {
        return {

            frontImage: null,
            backImage: null,
            rawOcrText: '',

        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        submit()
        {
            this.$store.dispatch(SAVE_IDENTITY_CARD_INFO, this.dataInfo).then((res) => {
                this.$message.success('Lưu thông tin thành công')
            })
        },
        resetForm() {
            this.frontImage = null;
            this.backImage = null;
            this.currentSide = 'front';
            this.ocrError = null; // Thêm dòng này
            this.rawOcrText = ''; // Thêm dòng này
            this.showRawText = false; // Thêm dòng này
            this.ocrProgress = 0; // Thêm dòng này
            this.dataInfo = {
                id_number: "",
                full_name: "",
                date_of_birth: "",
                gender: "",
                nationality: "",
                place_of_origin: "",
                place_of_residence: "",
                expiry_date: "",
                issued_date: "",
                issued_place: ""
            };
        },
    },
    computed: {
        progressWidth() {
            return (this.frontImage ? 50 : 0) + (this.backImage ? 50 : 0);
        },

    },
}
</script>

<style scoped>

</style>